'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ReactFormattedAmount = require('./ReactFormattedAmount');

var _ReactFormattedAmount2 = _interopRequireDefault(_ReactFormattedAmount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var I18nReactFormattedAmount = function render(props) {
  var format = props.format,
      lang = props.lang,
      separator = props.separator,
      currency = props.currency,
      currencyCode = props.currencyCode,
      NegWrap = props.NegWrap,
      rest = _objectWithoutProperties(props, ['format', 'lang', 'separator', 'currency', 'currencyCode', 'NegWrap']);

  var currencyProps = !currencyCode ? { format: format, currency: currency } : {
    format: format || I18nReactFormattedAmount.formatsPerCurrencyCode[currencyCode].format,
    currency: currency || I18nReactFormattedAmount.formatsPerCurrencyCode[currencyCode].currency
  };

  var childProps = _extends({}, rest, currencyProps, {
    separator: separator || I18nReactFormattedAmount.getFormat(lang).separator,
    NegWrap: NegWrap || I18nReactFormattedAmount.getFormat(lang).NegWrap
  });

  return _react2.default.createElement(_ReactFormattedAmount2.default, childProps);
};

I18nReactFormattedAmount.DEFAULT_LANGUAGE_NODE = 'en-US';

var RuNegWrap = function RuNegWrap(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ['children']);

  return _react2.default.createElement(
    'span',
    props,
    '\u2013' + children
  );
};
RuNegWrap.propTypes = { children: _propTypes2.default.string };

// current user language
I18nReactFormattedAmount.formatsPerLang = {
  fr: { separator: '.' },
  en: { separator: '.' },
  ru: { separator: '.', NegWrap: RuNegWrap }
};

// print currency (may differ than user lang)
I18nReactFormattedAmount.formatsPerCurrencyCode = {
  eur: { format: '%n %u', currency: '€' },
  usd: { format: '%u %n', currency: '$' },
  rub: { format: '%n%u', currency: '₽' }
};

I18nReactFormattedAmount.getFormat = function (lang) {
  var currentLanguage = (lang || I18nReactFormattedAmount.currentLanguage()).split('-')[0];
  return I18nReactFormattedAmount.formatsPerLang[currentLanguage];
};

I18nReactFormattedAmount.currentLanguage = function () {
  if (typeof window === 'undefined' || !window.navigator) {
    return I18nReactFormattedAmount.DEFAULT_LANGUAGE_NODE;
  }
  if (window.navigator.languages) {
    return window.navigator.languages[0];
  }
  return window.navigator.language || window.navigator.userLanguage;
};

I18nReactFormattedAmount.propTypes = {
  lang: _propTypes2.default.string,
  amount: _ReactFormattedAmount2.default.propTypes.amount,
  currency: _propTypes2.default.string,
  currencyCode: _propTypes2.default.oneOf(Object.keys(I18nReactFormattedAmount.formatsPerCurrencyCode)),
  format: _propTypes2.default.string,
  separator: _ReactFormattedAmount2.default.propTypes.separator,
  NegWrap: _ReactFormattedAmount2.default.propTypes.NegWrap
};

var _default = I18nReactFormattedAmount;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(I18nReactFormattedAmount, 'I18nReactFormattedAmount', 'src/I18nReactFormattedAmount.js');

  __REACT_HOT_LOADER__.register(RuNegWrap, 'RuNegWrap', 'src/I18nReactFormattedAmount.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/I18nReactFormattedAmount.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-formatted-amount/lib/I18nReactFormattedAmount.js
// module id = 1022
// module chunks = 0